document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-menu-toggle]').forEach(function(b){b.addEventListener('click',function(){var n=document.querySelector('[data-primary-nav]');if(!n)return;var o=n.classList.toggle('open');b.setAttribute('aria-expanded',o?'true':'false')})})});

// Simple CBM calculator; local-only, no data is submitted.
document.addEventListener('input', function(event) {
  const root = event.target.closest('[data-cbm-calculator]');
  if (!root) return;
  const get = (selector) => Math.max(0, Number(root.querySelector(selector)?.value || 0));
  const length = get('[data-cbm-length]');
  const width = get('[data-cbm-width]');
  const height = get('[data-cbm-height]');
  const qty = Math.max(1, get('[data-cbm-qty]'));
  const cbm = (length * width * height / 1000000) * qty;
  const result = root.querySelector('[data-cbm-result]');
  if (result) result.textContent = cbm.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3}) + ' m³';
});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-cbm-calculator]').forEach(function(root) {
    const input = root.querySelector('[data-cbm-length]');
    if (input) input.dispatchEvent(new Event('input', {bubbles:true}));
  });
});


// V3 directory filters: all content remains local and manually maintained in Shopify.
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-directory-browser]').forEach(function(root) {
    const search = root.querySelector('[data-directory-search]');
    const category = root.querySelector('[data-directory-category]');
    const area = root.querySelector('[data-directory-area]');
    const cards = Array.from(root.querySelectorAll('[data-directory-card]'));
    const count = root.querySelector('[data-directory-count]');
    const empty = root.querySelector('[data-directory-empty]');
    function update() {
      const q = (search && search.value || '').trim().toLowerCase();
      const c = category ? category.value : 'all';
      const a = area ? area.value : 'all';
      let visible = 0;
      cards.forEach(function(card) {
        const match = (!q || (card.dataset.search || '').includes(q)) && (c === 'all' || card.dataset.category === c) && (a === 'all' || card.dataset.area === a);
        card.hidden = !match; if (match) visible++;
      });
      if (count) count.textContent = visible + (visible === 1 ? ' location' : ' locations');
      if (empty) empty.hidden = visible !== 0;
    }
    [search, category, area].forEach(function(el) { if (el) el.addEventListener('input', update); });
    update();
  });
  document.querySelectorAll('[data-project-filters]').forEach(function(root) {
    const wrapper = root.parentElement;
    const cards = Array.from(wrapper.querySelectorAll('[data-project-card]'));
    const empty = wrapper.querySelector('[data-project-empty]');
    root.querySelectorAll('[data-project-filter]').forEach(function(button) {
      button.addEventListener('click', function() {
        const filter = button.dataset.projectFilter;
        root.querySelectorAll('[data-project-filter]').forEach(function(b) { b.classList.toggle('is-active', b === button); });
        let visible = 0;
        cards.forEach(function(card) {
          const raw = (card.dataset.projectCategory || '').toLowerCase();
          const normalized = raw.includes('residential') || raw.includes('whole-home') ? 'residential' : raw.includes('hospitality') || raw.includes('hotel') || raw.includes('restaurant') ? 'hospitality' : raw.includes('commercial') || raw.includes('office') ? 'commercial' : raw;
          const match = filter === 'all' || normalized === filter;
          card.hidden = !match; if (match) visible++;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });
  });
});

// V4: resource hub search and topic filters
 document.querySelectorAll('[data-resource-filters]').forEach(function(root) {
   const wrapper = root.closest('.resources-hub');
   if (!wrapper) return;
   const search = root.querySelector('[data-resource-search]');
   const topic = root.querySelector('[data-resource-topic]');
   const cards = Array.from(wrapper.querySelectorAll('[data-resource-card]'));
   const count = wrapper.querySelector('[data-resource-count]');
   const empty = wrapper.querySelector('[data-resource-empty]');
   function updateResources() {
     const q = (search && search.value || '').trim().toLowerCase();
     const t = topic ? topic.value : 'all';
     let visible = 0;
     cards.forEach(function(card) {
       const matches = (!q || (card.dataset.search || '').includes(q)) && (t === 'all' || card.dataset.topic === t);
       card.hidden = !matches;
       if (matches) visible++;
     });
     if (count) count.textContent = visible + (visible === 1 ? ' resource' : ' resources');
     if (empty) empty.hidden = visible !== 0;
   }
   [search, topic].forEach(function(el) { if (el) el.addEventListener('input', updateResources); });
   updateResources();
 });

// V4: indicative landed-cost calculator. Import tax is applied to goods + freight + insurance + duty estimate.
 document.querySelectorAll('[data-landed-calculator]').forEach(function(root) {
   const get = function(name) { const el = root.querySelector('[data-lc-' + name + ']'); return el ? (parseFloat(el.value) || 0) : 0; };
   const out = function(name, value) { const el = root.querySelector('[data-lc-' + name + ']'); if (!el) return; const currency = root.querySelector('[data-lc-currency]')?.value || 'USD'; try { el.textContent = new Intl.NumberFormat(undefined, {style:'currency', currency:currency, maximumFractionDigits:2}).format(value); } catch(e) { el.textContent = currency + ' ' + value.toFixed(2); } };
   function calculate() {
     const goods = Math.max(0,get('goods'));
     const origin = Math.max(0,get('origin'));
     const freight = Math.max(0,get('freight'));
     const insurance = Math.max(0,get('insurance'));
     const dutyRate = Math.max(0,Math.min(100,get('duty')))/100;
     const taxRate = Math.max(0,Math.min(100,get('tax')))/100;
     const destination = Math.max(0,get('destination'));
     const duty = (goods + freight + insurance) * dutyRate;
     const tax = (goods + freight + insurance + duty) * taxRate;
     out('total', goods + origin + freight + insurance + duty + tax + destination);
     out('duty-result', duty);
     out('tax-result', tax);
     out('logistics', origin + freight + insurance + destination);
   }
   root.querySelectorAll('input,select').forEach(function(el) { el.addEventListener('input',calculate); el.addEventListener('change',calculate); });
   calculate();
 });


// Brief form attachments: uploads through the store owner's Cloudinary unsigned preset,
// then includes the resulting secure URLs in the Shopify contact notification.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-brief-form]').forEach(function (root) {
    const form = root.closest('form');
    const input = root.querySelector('[data-brief-files]');
    const fileList = root.querySelector('[data-brief-file-list]');
    const clearButton = root.querySelector('[data-brief-clear-files]');
    const status = root.querySelector('[data-brief-upload-status]');
    const submitButton = root.querySelector('[data-brief-submit]');
    const messageField = root.querySelector('[name="contact[body]"]');
    if (!form || !input || !fileList || !status || !submitButton || !messageField) return;

    const maxFiles = 6;
    const maxBytes = 15 * 1024 * 1024;
    const allowedExtensions = new Set(['pdf','doc','docx','xls','xlsx','jpg','jpeg','png','webp','dwg','zip']);
    let bypassNextSubmit = false;
    let busy = false;

    function setStatus(message, kind) {
      status.textContent = message || '';
      status.classList.toggle('is-error', kind === 'error');
      status.classList.toggle('is-success', kind === 'success');
    }

    function validateFiles(files) {
      if (files.length > maxFiles) return 'Please choose no more than 6 files.';
      for (const file of files) {
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowedExtensions.has(extension)) return 'Unsupported file type: ' + file.name + '. Use PDF, Word, Excel, JPG, PNG, WebP, DWG or ZIP.';
        if (file.size > maxBytes) return file.name + ' is larger than 15 MB. Please choose a smaller file.';
      }
      return '';
    }

    function renderFiles() {
      fileList.innerHTML = '';
      const files = Array.from(input.files || []);
      if (clearButton) clearButton.hidden = files.length === 0;
      files.forEach(function (file) {
        const chip = document.createElement('span');
        chip.className = 'brief-file-chip';
        const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
        chip.textContent = file.name + ' · ' + sizeMb + ' MB';
        fileList.appendChild(chip);
      });
      if (!files.length) setStatus('', '');
      else {
        const error = validateFiles(files);
        setStatus(error || (files.length + (files.length === 1 ? ' file selected.' : ' files selected.')), error ? 'error' : '');
      }
    }

    input.addEventListener('change', function () {
      const files = Array.from(input.files || []);
      const error = validateFiles(files);
      if (error) {
        setStatus(error, 'error');
        fileList.innerHTML = '';
        if (clearButton) clearButton.hidden = false;
      } else {
        renderFiles();
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        renderFiles();
      });
    }

    form.addEventListener('submit', async function (event) {
      if (bypassNextSubmit) {
        bypassNextSubmit = false;
        return;
      }
      if (busy) {
        event.preventDefault();
        return;
      }
      const files = Array.from(input.files || []);
      if (!files.length) return; // Native Shopify contact form submission, no attachments.

      event.preventDefault();
      const validationError = validateFiles(files);
      if (validationError) {
        setStatus(validationError, 'error');
        return;
      }
      const cloudName = (root.dataset.cloudinaryCloud || '').trim();
      const uploadPreset = (root.dataset.cloudinaryPreset || '').trim();
      if (!cloudName || !uploadPreset) {
        setStatus('File uploads are not connected yet. Configure Cloudinary in Theme settings → File uploads, or remove the selected files and submit the brief without attachments.', 'error');
        return;
      }

      busy = true;
      submitButton.disabled = true;
      const originalButtonHtml = submitButton.innerHTML;
      const originalBody = messageField.value;
      const uploadedUrls = [];
      try {
        for (let index = 0; index < files.length; index++) {
          const file = files[index];
          setStatus('Uploading attachment ' + (index + 1) + ' of ' + files.length + '…', '');
          submitButton.innerHTML = 'Uploading ' + (index + 1) + ' / ' + files.length + '…';
          const payload = new FormData();
          payload.append('file', file);
          payload.append('upload_preset', uploadPreset);
          const response = await fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloudName) + '/auto/upload', {
            method: 'POST',
            body: payload
          });
          let result = {};
          try { result = await response.json(); } catch (parseError) { result = {}; }
          if (!response.ok || !result.secure_url) {
            const message = result && result.error && result.error.message ? result.error.message : 'Upload failed for ' + file.name + '.';
            throw new Error(message);
          }
          uploadedUrls.push(result.secure_url);
        }

        const attachmentText = '\n\nAttachments uploaded:\n' + uploadedUrls.map(function (url, index) {
          return (index + 1) + '. ' + files[index].name + ': ' + url;
        }).join('\n');
        messageField.value = originalBody + attachmentText;
        setStatus('Attachments uploaded. Sending your brief…', 'success');
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonHtml;
        bypassNextSubmit = true;
        form.requestSubmit(submitButton);
      } catch (error) {
        messageField.value = originalBody;
        setStatus('We could not upload the attachments. ' + (error && error.message ? error.message : 'Please try again, or send the files later by email or through the Contact Us page.'), 'error');
        busy = false;
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonHtml;
      }
    });
  });
});


// V12: accessible floating customer-service panel; it does not lock or hijack page scrolling.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-customer-service-widget]').forEach(function (widget) {
    const toggle = widget.querySelector('[data-customer-service-toggle]');
    const panel = widget.querySelector('[data-customer-service-panel]');
    const close = widget.querySelector('[data-customer-service-close]');
    if (!toggle || !panel || !close) return;

    function openPanel() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        const firstFocusable = panel.querySelector('button, a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), summary');
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
        else panel.focus({ preventScroll: true });
      });
    }
    function closePanel(returnFocus) {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus({ preventScroll: true });
    }
    toggle.addEventListener('click', function () {
      if (panel.hidden) openPanel(); else closePanel(false);
    });
    close.addEventListener('click', function () { closePanel(true); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) closePanel(true);
    });
  });
});


// Furnvila conversion tracking hooks. These events contain no form values or personal data.
(function () {
  var sentLeadEvents = new WeakSet();
  function publishEvent(name, data) {
    var details = Object.assign({ event: name, page_path: window.location.pathname }, data || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('furnvila:' + name, details);
      }
    } catch (error) { /* Analytics must never block navigation or form submission. */ }
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(details);
    } catch (error) { /* Optional GTM data layer. */ }
    try {
      if (typeof window.gtag === 'function') {
        var gaData = Object.assign({}, details); delete gaData.event;
        window.gtag('event', name, gaData);
      }
    } catch (error) { /* Optional GA4 gtag. */ }
    try { document.dispatchEvent(new CustomEvent('furnvila:tracking', { detail: details })); } catch (error) {}
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href],button') : null;
    if (!target) return;
    var href = target.getAttribute('href') || '';
    var label = (target.getAttribute('data-cta-label') || target.textContent || target.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 120);
    if (/^(mailto:)/i.test(href)) publishEvent('email_click', { link_url: href.split('?')[0] });
    if (/whatsapp\.com|wa\.me/i.test(href) || target.hasAttribute('data-track-whatsapp')) publishEvent('whatsapp_click', { link_url: href.split('?')[0] });
    if (target.matches('[data-track-cta],a.button,button.button,.header-cta,.trip-book-button') || target.classList.contains('text-link')) {
      publishEvent('cta_click', { cta_label: label, link_url: href ? href.split('?')[0] : '', cta_class: target.className || '' });
    }
  }, true);
  document.addEventListener('focusin', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('[data-enquiry-form]') : null;
    if (!root || root.dataset.enquiryTracked === 'true') return;
    root.dataset.enquiryTracked = 'true';
    publishEvent('project_enquiry_started', { form_source: root.dataset.enquirySource || 'unspecified' });
  });
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-track-lead-success]').forEach(function (node) {
      if (sentLeadEvents.has(node)) return;
      sentLeadEvents.add(node);
      publishEvent('generate_lead', { form_source: node.getAttribute('data-lead-source') || 'contact-form' });
    });
  });
})();
